import React, { useEffect } from 'react';
import { SidebarWithHeader, DashboardCards, OrdersTable } from '../components';
import { useOrderContext } from '../context/order_context';
import { useNotificationContext } from '../context/notification_context';
import { Button, HStack } from '@chakra-ui/react';
import { MdOutlineRefresh, MdNotificationsActive, MdNotificationsOff } from 'react-icons/md';

export default function Dashboard() {
  const { orders, fetchOrders } = useOrderContext();
  const { isEnabled, toggleNotifications } = useNotificationContext();

  // Fetch orders on component mount
  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sort orders by date (newest first) to show all orders
  const sortedOrders = [...orders].sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  });

  const handleRefresh = async () => {
    await fetchOrders();
  };

  return (
    <SidebarWithHeader>
      <DashboardCards />
      <HStack mb={5}>
        <Button
          colorScheme='brown'
          variant='outline'
          leftIcon={<MdOutlineRefresh />}
          onClick={handleRefresh}
        >
          Refresh Orders
        </Button>
        <Button
          colorScheme={isEnabled ? 'green' : 'gray'}
          variant={isEnabled ? 'solid' : 'outline'}
          leftIcon={isEnabled ? <MdNotificationsActive /> : <MdNotificationsOff />}
          onClick={toggleNotifications}
        >
          {isEnabled ? 'Notifications activées' : 'Activer les notifications'}
        </Button>
      </HStack>
      <OrdersTable orders={sortedOrders} />
    </SidebarWithHeader>
  );
}
